import { render } from "./floating.vue?vue&type=template&id=2b1380f2&scoped=true"
import script from "./floating.vue?vue&type=script&lang=js"
export * from "./floating.vue?vue&type=script&lang=js"

import "./floating.vue?vue&type=style&index=0&id=2b1380f2&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1380f2"]])

export default __exports__